import { ReduxState } from '@batical/reducer/src/reducers'
import { UserState } from '@batical/reducer/src/User'
import { createSelector } from 'reselect'

export const selectUser = (state: ReduxState) => state.user
export const selectUserId = createSelector([(state: ReduxState) => state.user], (value: UserState) => value.id)
export const selectStripeCustomerId = createSelector([(state: ReduxState) => state.user], (value: UserState) => value.stripeCustomerId)
